import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import LayeredDashboardHeader from '../../pages/LayeredDashboardHeader';
const DashboardSubTabs = ({ subTabs, activeTab }) => {
  const navigate = useNavigate();

  return (
    <>
      {activeTab?.grid && <LayeredDashboardHeader tab={activeTab}></LayeredDashboardHeader>}

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3  2xl:grid-cols-4 gap-[20px] p-[40px] ">
        {subTabs?.map(subTab => {
          return (
            <div
              className="flex flex-row  p-[15px] gap-[10px] bg-[#FFFFFF] border-[1.5px] border-[#E3E8EF] rounded-[15px] cursor-pointer"
              onClick={() => {
                !subTab.isDisabled && navigate(subTab.pointTo);
              }}
              style={{
                cursor: subTab.isDisabled ? 'not-allowed' : 'pointer',
                opacity: subTab.isDisabled ? '0.5' : '1',
              }}
            >
              <div className="bg-[#F8F8F8] w-[60px] h-[60px] flex items-center justify-center rounded-md">
                {subTab?.icon?.component && (
                  <subTab.icon.component className={`${subTab.icon.classNames}`}></subTab.icon.component>
                )}
              </div>
              <div className="flex flex-col">
                <div className="text-bold text-[15px] text-[#5E5873]">{subTab.title}</div>
                <div className=" text-[13px] text-[#5E5873]">{subTab.description}</div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default DashboardSubTabs;
